import { render, staticRenderFns } from "./JeecgOrderMainListForJEditableTable.vue?vue&type=template&id=1f128885&scoped=true"
import script from "./JeecgOrderMainListForJEditableTable.vue?vue&type=script&lang=js"
export * from "./JeecgOrderMainListForJEditableTable.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderMainListForJEditableTable.vue?vue&type=style&index=0&id=1f128885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f128885",
  null
  
)

export default component.exports